import { render, staticRenderFns } from "./IssueResponseNum.vue?vue&type=template&id=742c2edd"
import script from "./IssueResponseNum.vue?vue&type=script&lang=js"
export * from "./IssueResponseNum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports